import useAuth from '@app/auth/use-auth';
import { SidebarInset } from '@shared/components/ui/sidebar';
import { ReactNode } from 'react';
import { AppSidebar } from './sidebar/components/app-sidebar';

const Layout = ({ children }: { children: ReactNode }) => {
  const { user } = useAuth();
  if (!user) {
    return children;
  }
  return (
    <>
      <AppSidebar />
      <SidebarInset className="h-full bg-gray-25">{children}</SidebarInset>
    </>
  );
};

export default Layout;
